import { includes, filter, get } from 'lodash';

export const getImages = (data) => get(data, 'items', []);

export const getSelectedImages = (data, ids) =>
    filter(getImages(data), (item) => includes(ids, get(item, 'name', '')));
